// getStatsByApplicationForFamilyById
export const VaultPlatformLabel = 'Vault Platform';
export const VaultPlatformKey = 'platform__v';
export const AppStatsQAPlatformKey = 'appstats_qa_platform__v';
